<template>
  <li class="nav-item nav-item-page">
    <router-link 
      class="nav-link nav-link-page" 
      :to="to"
      active-class="active"
      @click="$emit('click')"
    >
      <span class="nav-link-text">{{ label }}</span>
      <span class="nav-link-indicator"></span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    to: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.nav-item-page {
  position: relative;
}

.nav-link-page {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1.5rem;
  color: white !important;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin: 0.125rem 0;
}

.nav-link-page .nav-link-text {
  color: white !important;
}

.nav-link-page::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.15), transparent);
  transition: width 0.3s ease;
}

.nav-link-page:hover::before {
  width: 100%;
}

.nav-link-text {
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.nav-link-indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 3px;
  height: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4));
  border-radius: 0 2px 2px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
}

.nav-link-page:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateX(6px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-link-page:hover .nav-link-text {
  transform: translateX(2px);
  color: white !important;
}

.nav-link-page.active {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.12);
}

.nav-link-page.active .nav-link-text {
  color: white !important;
}

.nav-link-page.active .nav-link-indicator {
  height: 60%;
  transform: translateY(-50%) scaleY(1);
}

.nav-link-page:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* Desktop styles */
@media (min-width: 992px) {
  .nav-link-page {
    padding: 0.5rem 1rem;
    color: white !important;
    margin: 0;
  }

  .nav-link-page .nav-link-text {
    color: white !important;
  }

  .nav-link-page:hover {
    transform: translateY(0);
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: none;
    color: white !important;
  }

  .nav-link-page:hover .nav-link-text {
    transform: translateX(0);
    color: white !important;
  }
}
</style>

